import axios from 'axios'
import { CLEAR_CUSTOMER_LOAD, CUSTOMER_LOADS_LOADING, GET_ALL_CUSTOMER_LOADS, GET_CUSTOMER_LOAD } from './types'

import { notificationDanger } from './../../../utils/customToastify'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'

export const clearCustomerLoad = () => (dispatch) => {
  dispatch({ type: CLEAR_CUSTOMER_LOAD })
}

const setLoading = (isLoading) => (dispatch) => {
  dispatch({ type: CUSTOMER_LOADS_LOADING, payload: isLoading })
}

export const getCustomerLoads = (contactId, options) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get(`/customers-logistic-loads/all/${contactId}`, { params: { ...options } })
    dispatch({ type: GET_ALL_CUSTOMER_LOADS, payload: res.data })
    dispatch(setLoading(false))
    dispatch(closeModal('create_load'))
  } catch (error) {
    //
  }
  dispatch(setLoading(false))
}

export const getCustomerLoad = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/customers-logistic-loads/${id}`)
    dispatch({ type: GET_CUSTOMER_LOAD, payload: res.data })
  } catch (error) {
    //
  }
}

export const createLoad = (data, options) => async (dispatch, getState) => {
  try {
    const state = getState()
    const contactId = state?.contacts?.contact?.id
    if (contactId) {
      await axios.post('/customers-logistic-loads', { ...data, contactId })
      dispatch(getCustomerLoads(contactId, options))
    } else {
      notificationDanger('Unable to obtain customer id')
    }
  } catch (e) {
    //
  }
}

export const updateLoad = (id, data, options) => async (dispatch, getState) => {
  try {
    const state = getState()
    const contactId = state?.contacts?.contact?.id
    if (id) {
      await axios.patch(`/customers-logistic-loads/${id}`, { ...data })

      dispatch(getCustomerLoads(contactId, options))
    }
  } catch (error) {
    //
  }
}

export const deleteLoad = (id, options) => async (dispatch, getState) => {
  try {
    const state = getState()
    const contactId = state?.contacts?.contact?.id

    await axios.delete(`/customers-logistic-loads/${id}`)
    if (contactId) {
      dispatch(getCustomerLoads(contactId, options))
    }
  } catch (error) {
    //
  }
}
